/**
 * List of loading states for retrieving data asynchronously.
 */
export var LoadingState;
(function (LoadingState) {
    /**
     * Data has not yet loaded or not been loading.
     */
    LoadingState["NotLoaded"] = "NotLoaded";
    /**
     * Data is in the process of being fetched.
     */
    LoadingState["Loading"] = "Loading";
    /**
     * Data was successfully retrieved.
     */
    LoadingState["Success"] = "Success";
    /**
     * An error occurred while retrieving the data.
     */
    LoadingState["Failure"] = "Failure";
})(LoadingState || (LoadingState = {}));
//# sourceMappingURL=loading-state.js.map